const toE164 = (number, country, utils) =>
  utils.isValidNumber(number, country)
    ? utils.formatNumber(number, country, utils.numberFormat.E164)
    : null;

export default function normalizePhoneNumber(value, country, utils) {
  if (typeof value !== 'string' || !value.trim() || !utils) return value;

  const iso2 = country?.toLowerCase() || '';

  if (value.trim().startsWith('+')) return toE164(value, iso2, utils) ?? value;

  return (iso2 && toE164(value, iso2, utils)) || toE164(`+${value.trim()}`, '', utils) || value;
}
